// extracted by mini-css-extract-plugin
module.exports = {"no-results":"ErrorMessage_no-results__7jG01","title-wrapper":"ErrorMessage_title-wrapper__2kBMK"};